<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="!isLoading && currentMonth != null"></cre-spinner>
</div>
<div *ngIf="!!monthList && monthList.length > 0 && monthList[currentMonthIndex]">
  <app-expandable-panel [cardType]="true">
    <div
      class="cre-wig-monthly-competition-details-carousel-control"
      *ngIf="monthList != null && monthList.length > 0"
    >
      <div
        class="cre-wig-monthly-competition-details-carousel-control-button"
        (click)="previousMonth()"
      >
        <fa-icon [icon]="['fas', 'caret-left']"></fa-icon>
      </div>
      <span class="cre-wig-monthly-competition-details-title">
        {{ monthList[currentMonthIndex].month }}
      </span>
      <div
        class="cre-wig-monthly-competition-details-carousel-control-button"
        (click)="nextMonth()"
      >
        <fa-icon [icon]="['fas', 'caret-right']"></fa-icon>
      </div>
    </div>
  </app-expandable-panel>

  <p-carousel
    [page]="currentMonthIndex"
    [numVisible]="1"
    [value]="driverStats"
    #monthlyStatsCarousel
  >
    <ng-template let-driverStat pTemplate="item">
      <app-expandable-panel [cardType]="true">
        <div
          class="cre-wig-weekly-competition-details-content"
          (swipeleft)="nextMonth()"
          (swiperight)="previousMonth()"
        >
          <section  >
            <div class="cre-wig-stats-sidebar-scroll">
              <div
                class="p-grid stat-panel-grid cre-wig-stats-sidebar-body-max-height"
                *ngIf="!isLoading && currentMonth != null"
                #statPanelGrid
                [style.paddingLeft.px]="statPanelMargin"
                [style.paddingRight.px]="statPanelMargin"
              >
                <app-stat-panel
                  class="p-col"
                  (click)="displayAccidentDetails()"
                  [icon]="'car-crash'"
                  [label]="'Accidents'"
                  [value]="driverStat.accidentCount"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayCriticalEventsDetails()"
                  [icon]="'car-bump'"
                  [label]="'Critical Events'"
                  [value]="driverStat.criticalEventCount!"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayLateArrivalsDetails()"
                  [icon]="'clock'"
                  [label]="'Late Arrivals'"
                  [value]="driverStat.lateArrivalCount"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displaySafetyVideoDetails()"
                  [icon]="'play-circle'"
                  [label]="'Safety Video'"
                  [value]="
                                !driverStat.safetyVideoNotAssigned
                                  ? driverStat.safetyVideoCompletion === percentageSafetyVideoCompleted
                                    ? true
                                    : false
                                  : '-'
                              "
                >
                </app-stat-panel>
                <app-stat-panel
                  *ngFor="let commitment of driverStat.commitmentStats"
                  class="p-col"
                  (click)="displayCommitmentDetails(commitment.leadId)"
                  [icon]="commitment.icon"
                  [label]="commitment.leadSubject"
                  [value]="commitment.commitmentCount + '/' + commitment.commitmentDenominator"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayHuddleSidebar()"
                  [icon]="'users'"
                  [label]="'Huddle'"
                  [value]="driverStat.wigAttendanceCounts + '/' + driverStat.wigAttendanceDenominator"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayDVR()"
                  [icon]="'truck'"
                  [label]="'Missing DVIR'"
                  [value]="driverStat.dvirCount"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayMissingPaperwok()"
                  [icon]="'file-check'"
                  [label]="'Missing Paperwork'"
                  [value]="driverStat.paperworkCount"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayCSAViolation()"
                  [icon]="'traffic-cone'"
                  [label]="'CSA Violations'"
                  [value]="driverStat.csaViolationCount"
                >
                </app-stat-panel>
                <app-stat-panel
                  class="p-col"
                  (click)="displayLogViolation()"
                  [icon]="'calendar-exclamation'"
                  [label]="'Log Violations'"
                  [value]="driverStat.logViolationCount"
                >
                </app-stat-panel>
              </div>
            </div>
          </section>
        </div>
      </app-expandable-panel>
    </ng-template>
  </p-carousel>
</div>

<p-sidebar
  [blockScroll]="true"
  (onHide)="clearSidebar()"
  position="bottom"
  [showCloseIcon]="false"
  styleClass="cre-wig-stats-details-sidebar"
  [(visible)]="isSidebarVisible"
>
  <div class="cre-wig-stats-details-sidebar-icon" *ngIf="isSidebarVisible">
    <fa-icon (click)="hideSidebar()" [icon]="['fal', 'times']" [size]="'3x'"> </fa-icon>
  </div>

  <!--Accidents Details-->
  <ng-container *ngIf="isAccidentSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Accidents</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let accident of accidentDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ accident.date | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ accident.location }}</div>
          <div class="p-col-fixed p-col-slider">{{ accident.accidentType }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Critical Events Details-->
  <ng-container *ngIf="isCriticalEventsSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Critical Events</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let criticalEvent of criticalEventsDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ criticalEvent.recordedDateTime | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ criticalEvent.location }}</div>
          <div class="p-col-fixed p-col-slider">{{ criticalEvent.observations }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Late Arrival Details-->
  <ng-container *ngIf="isLateArrivalsSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Late Arrival</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let lateArrival of lateArrivalsDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ lateArrival.date | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ lateArrival.location }}</div>
          <div class="p-col-fixed p-col-slider">{{ lateArrival.trip }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Commitment Details-->
  <ng-container *ngIf="isCommitmentSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Commitments</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body cre-wig-stats-details-sidebar-body-max-height">
        <div class="p-grid p-grid-slider" *ngFor="let commitment of commitmentDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ commitment.date | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">
            {{ commitment.status.replace('Can Respond', 'Please Reply') }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Wig Attendance Details-->
  <ng-container *ngIf="isWigAttendanceSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Huddle attendance</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let wigAttendance of wigAttendanceDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ wigAttendance.conferenceDate | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ wigAttendance.hasCalledIn }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Safety Videos Details-->
  <ng-container *ngIf="isSafetyVideoSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Safety Video</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div
          class="p-grid p-grid-slider special-grid-size"
          *ngFor="let safetyVideo of safetyVideosDetails"
        >
          <div class="p-col-fixed p-col-slider">
            {{ safetyVideo.description }}
          </div>
          <div class="p-col-fixed p-col-slider">No</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Missing Paperwork Details-->
  <ng-container *ngIf="isMissingPaperworkSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Missing Paperwork</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let missingPaperwork of missingPaperworkDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ missingPaperwork.detailDate | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ missingPaperwork.description }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Missing DVR Details-->
  <ng-container *ngIf="isDVIRSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Missing DVIR</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let dvr of missingDVRDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ dvr.detailDate | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ dvr.description }}</div>
          <div class="p-col-fixed p-col-slider">{{ 'No DVIR found' }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--CSA Violation Details-->
  <ng-container *ngIf="isCSAViolationSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">CSA Violations</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let csaViolation of csaViolationDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ csaViolation.detailDate | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ csaViolation.description }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--CSA Violation Details-->
  <ng-container *ngIf="isLogViolationSidebarVisible">
    <div class="cre-wig-stats-details-sidebar-header">Log Violations</div>
    <div class="cre-wig-stats-details-sidebar-scroll">
      <div class="cre-wig-stats-details-sidebar-body">
        <div class="p-grid p-grid-slider" *ngFor="let logViolation of logViolationDetails">
          <div class="p-col-fixed date-cell p-col-slider">
            {{ logViolation.detailDate | date : 'shortDate' }}
          </div>
          <div class="p-col-fixed p-col-slider">{{ logViolation.description }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--Details Spinner-->
  <div class="p-grid p-justify-center">
    <cre-spinner [size]="'md'" [hidden]="!isLoadingDetails"></cre-spinner>
  </div>
</p-sidebar>
